import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerService } from './ServerService';

@Injectable({
  providedIn: 'root'
})
export class SuporteContatosWhatsappService extends ServerService {
  private endpoint = '/suporte-contatos';

  constructor(protected http: HttpClient) {
    super(http);
  }

  obtenhaContexto(telefone: string, chatId: string, nome: string): Promise<any> {
    return this.facaPost(`${this.endpoint}/whatsapp/contexto`, { telefone, chatId, nome });
  }

  vinculeContato(dados: any): Promise<any> {
    return this.facaPost(`${this.endpoint}/whatsapp/vincular`, dados);
  }

  desvinculeContato(dados: any): Promise<any> {
    return this.facaPost(`${this.endpoint}/whatsapp/desvincular`, dados);
  }

  listeUsuariosEmpresa(empresaId: number): Promise<any[]> {
    return this.obtenha(`${this.endpoint}/empresas/${empresaId}/usuarios`, {});
  }
}
